import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import TextArea from "../../components/elements/TextArea";
import Button from "../../components/elements/Button";
import {ADMIN_API_BASE} from "../../utils/apiConfig";
import {faAdd, faBook, faSave, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CustomSelect from "../../components/elements/CustomSelect";

const AdminRules = () => {
    const [rules, setRules] = useState([]);
    const [newRule, setNewRule] = useState(null);
    const [error, setError] = useState('');
    const [blockType, setBlockType] = useState("text");
    const [blockText, setBlockText] = useState("");

    const handleAddBlock = () => {
        if (!blockText.trim()) return;

        const newBlock = {
            type: blockType,
            text: blockText
        };

        setNewRule(prev => ({
            ...prev,
            content: [...prev.content, newBlock]
        }));

        setBlockText("");
    };


    const fetchRules = async () => {
        try {
            const token = await getCsrfToken();
            const res = await axios.get(`${ADMIN_API_BASE}/rules`,
                {
                    headers: {'csrf-token': token},
                    withCredentials: true
                }
            );
            if (res.data.success && res.data.rules != null) {
                setRules(res.data.rules);
            } else {
            }
        } catch (e) {
            setError(e);
        }
    };

    const handleAddButtonClick = () => {
        setNewRule({ language_id: "", content: [] });
    };

    useEffect(() => {
        fetchLanguages()
        fetchRules()
    }, []);

    const [languagesOptions, setLanguagesOptions] = useState([]);

    const fetchLanguages = async () => {
        try {
            const token = await getCsrfToken();
            const res = await axios.get(`${ADMIN_API_BASE}/language`,
                {
                    headers: {'csrf-token': token},
                    withCredentials: true
                }
            );

            if (res.data.success) {
                const options = res.data.languages.languages.map(l => l.id);
                setLanguagesOptions(options);
            } else {
            }
        } catch (e) {
            setError(e);
        }
    };

    const handleInsert = async () => {
        try {
            const token = await getCsrfToken();
            const res = await axios.post(`${ADMIN_API_BASE}/rules`,
                {
                    language_id: newRule.language_id,
                    content: newRule.content
                },
                {
                    headers: {'csrf-token': token},
                    withCredentials: true
                }
            );
            setNewRule([]);
            fetchRules();
        } catch (e) {
            alert(e)
            setError(e);
        }
    };

    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='قوانین'/>
                        <div className='w-full flex flex-col px-10 flex-1 my-10'>
                            <Button onClick={handleAddButtonClick}>
                                <FontAwesomeIcon icon={faAdd} className="mr-2"/>
                                <span>اضافه‌کردن قوانین ‌جدید</span>
                            </Button>
                        </div>
                        <div className='bg-red-200 p-3 m-5 flex rounded-sm'>
                        </div>
                        <div className={`px-10 flex-1 my-10 gap-4 ${newRule != null ? 'flex flex-col' : 'hidden'}`}>
                            <CustomSelect
                                value={newRule != null ? newRule.language_id : ''}
                                options={languagesOptions}
                                title="زبان"
                                onChange={(e) => {
                                    setNewRule((prev) => ({
                                        ...prev,
                                        language_id: e.target.value,
                                    }));
                                }}
                            />
                            <div className="flex flex-col gap-3">
                                <CustomSelect
                                    value={blockType}
                                    options={["heading", "text"]}
                                    title="نوع"
                                    onChange={(e) => setBlockType(e.target.value)}
                                />

                                <TextArea
                                    value={blockText}
                                    title="متن"
                                    onChange={(e) => setBlockText(e.target.value)}
                                />

                                <Button className="w-fit" onClick={handleAddBlock}>
                                    <FontAwesomeIcon icon={faAdd} className="mr-2"/>
                                    <span>افزودن</span>
                                </Button>
                            </div>
                            <Button className={'w-fit'} onClick={handleInsert}>
                                <FontAwesomeIcon icon={faSave} className="mt-2" size={'lg'}/>
                            </Button>
                        </div>
                        <div className="flex flex-col gap-2 m-10 mt-4">
                            {newRule?.content?.map((block, i) => (
                                <div key={i} className="p-3 bg-gray-200 rounded flex justify-between">
                                    <div>
                                        {block.type === "heading" ? (
                                            <h3 className="font-bold">{block.text}</h3>
                                        ) : (
                                            <p>{block.text}</p>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => {
                                            setNewRule(prev => ({
                                                ...prev,
                                                content: prev.content.filter((_, idx) => idx !== i)
                                            }));
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrashCan}/>
                                    </button>
                                </div>
                            ))}
                        </div>
                        <div className="flex p-5 w-full flex-col gap-4 bg-gray-100 rounded-md">
                            {rules && rules.length > 0 && (
                                rules.map((item, index) => (
                                    <div className='flex flex-col w-full p-5 bg-gray-200 rounded-md' key={index}>
                                        <h2>{item.language_id}</h2>
                                        {item.content.map((block, i) => (
                                            block.type === "heading"
                                                ? <h3 key={i} className="font-bold">{block.text}</h3>
                                                : <p key={i}>{block.text}</p>
                                        ))}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminRules;
